// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2d7GC","label":"Category_label__3IOhs","content":"Category_content__284_k","header":"Category_header__1q-sw","location":"Category_location__2P8Qw"};